import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import QuestionsController from './QuestionsController';

import panel from '../../services';

import questionsProfile from '../../directives/questionsProfile';
import questionsMatch from '../../directives/questionsMatch';
import questionsChemistry from '../../directives/questionsChemistry';

export default angular.module('app.questions', [
    uirouter,
    panel,
    questionsProfile,
    questionsMatch,
    questionsChemistry
])
    .config(routing)
    .controller('QuestionsController', QuestionsController)
    .name;


// WEBPACK FOOTER //
// ./src/app/features/questions/index.js